const integrations = {
  backToIntegrations: 'אינטגרציות',
  enabled: 'מופעל',
  outOfService: 'בקרוב...',
  enable: 'הפעל',
  updateIntegration: 'עדכן',
  app: {
    actions: {
      disable: {
        button: 'השבת',
        success: 'האינטגרציה הושבתה בהצלחה',
        failure: 'אירעה שגיאה בעת השבתת האינטגרציה',
        confirmModal: {
          header: 'אשר ניתוק אינטגרציה',
          body: 'כדי לכבות את האינטגרציה, הזן את המילה \'כיבוי\' בשדה הטקסט ואשר',
          verificationPhrase: 'כיבוי',
        },
      },
      oneTwoWayVerificationModal: {
        toOneWayInstructions: 'כדי לשנות את האינטגרציה לכיוון אחד, הכנס את המילה \'שינוי\' לשדה הטקסט ואשר.',
        toTwoWayInstructions: 'כדי לשנות את האינטגרציה למצב דו-כיווני, הכנס את המילה \'שינוי\' לשדה הטקסט ואשר.',
        verificationPhrase: 'שינוי',
      },
      submit: {
        success: 'הפעולה המותאמת החלה בהצלחה',
        failure: 'אירעה שגיאה בעת התחלת הפעולה המותאמת',
      },
    },
  },
  form: {
    submit: {
      enable: {
        success: 'האינטגרציה הופעלה בהצלחה. פעולות מותאמות החלו...',
        failure: 'לא ניתן להפעיל את האינטגרציה. בדוק את הגדרות האימות שלך',
      },
    },
  },
  categories: {
    all: 'הכל',
    communications: 'תקשורת',
    dispatch: 'שיגור',
    finance: 'פיננסים',
    vehicleIntegration: 'אינטגרציית ציי רכבים',
  },
};

export default integrations;
